import { GetAakRulesResponse } from "@/app/api/aak-rules/route";
import { getAakRulesRequestSchema } from "@/lib/schemas/aak-rules";
import { createInvalidateQuery, createQueryHook } from "@/lib/queries";

const AAK_RULES_ENDPOINT = "/api/aak-rules";

export const invalidateAakRulesQuery =
  createInvalidateQuery(AAK_RULES_ENDPOINT);

export const useAakRulesQuery = createQueryHook<GetAakRulesResponse>(
  AAK_RULES_ENDPOINT,
  getAakRulesRequestSchema,
);
